import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { ENDPOINTS } from "../../../js/api/_config";


export const getTrails = createAsyncThunk('/getTrails', async (data, { rejectWithValue }) => {
    try {
        const response = await axios.get(`${ENDPOINTS.TRIALS.GET_ALL_TRIAL}`)
        return response.data;

    } catch (error) {
        return rejectWithValue(
            error.response?.data ||
            "Something went wrong while fetching the buyer profile."
        );
    }
})

const initialState = {
    data: [],
    isLoading: true,
    error: null,
};

const getTrailsSlice = createSlice(
    {
        name: "trials",
        initialState,
        extraReducers: (builder) => {
            builder.addCase(getTrails.fulfilled, (state, action) => {
                state.data = action.payload.data;
                state.isLoading = false;
                state.error = null;
            })
                .addCase(getTrails.pending, (state) => {
                    state.isLoading = true;
                    state.error = null;
                })
                .addCase(getTrails.rejected, (state, action) => {
                    state.isLoading = false;
                    state.error = action.payload;
                })
        }
    }
)

export default getTrailsSlice.reducer;